import { type IAccountStatusHistory } from "@apis/accounts/types"
import { useAccount } from "@apis/accounts/useAccounts"
import type { TTitleValueItem } from "@components/TitleValueList/types"
import { formatDate } from "@utils/formatters"

type TAgedAccountData = {
  first_name: string | undefined
  last_name: string | undefined
  membership_profile_id: string | undefined
  account_id: number | undefined
  account_status_histories: IAccountStatusHistory[] | undefined
  bill_cycle: string | undefined
  utility_code: string | undefined
  revenue_class_code: string | undefined
  confirmed_start_dt: string | undefined
  confirmed_drop_dt: string | undefined | null
  items: TTitleValueItem[]
}

export const useAgedAccountSerializer = (account_id: string) => {
  const getAccount = useAccount(account_id)

  const data: TAgedAccountData = {
    first_name: getAccount.data?.first_name,
    last_name: getAccount.data?.last_name,
    membership_profile_id: getAccount.data?.membership_profile_id,
    account_id: getAccount.data?.account_id,
    account_status_histories: getAccount.data?.account_status_histories,
    bill_cycle: getAccount.data?.bill_cycle,
    utility_code: getAccount.data?.market?.utility_code,
    revenue_class_code: getAccount.data?.revenue_class_code,
    confirmed_start_dt: getAccount.data?.confirmed_start_dt,
    confirmed_drop_dt: getAccount.data?.confirmed_drop_dt,
    items: [
      {
        title: { content: "Account ID" },
        value: {
          content: getAccount.data?.account_id,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Account Number" },
        value: {
          content: getAccount.data?.account_number,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Product Name" },
        value: {
          content: getAccount.data?.product_name,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Revenue Class" },
        value: {
          content: getAccount.data?.revenue_class_name,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Utility" },
        value: {
          content: getAccount.data?.market_code,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Sale Date" },
        value: {
          content: formatDate(getAccount.data?.sale_dt),
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Channel Code" },
        value: {
          content: getAccount.data?.channel_code,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Channel Partner Code" },
        value: {
          content: getAccount.data?.channel_partner_code,
          isPending: getAccount.isPending,
        },
      },
      {
        title: { content: "Current Status" },
        value: {
          content: getAccount.data?.account_status_code,
          isPending: getAccount.isPending,
          className: "tw:break-all",
        },
      },
    ],
  }

  return {
    data,
    isError: getAccount.isError,
    isPending: getAccount.isPending,
  }
}
